import type { SwapDto, SwapStatus } from '../types/coreApi-types'

interface TransactionStatus {
  transferStatus: SwapStatus
  title: string
  description?: string
}

export default function getStatusFromSwap(swap: SwapDto): TransactionStatus {
  // Use the swap's current status instead of individual deposit/withdraw statuses
  switch (swap.swapStatus) {
    case 'Created':
      return {
        transferStatus: 'Created',
        title: 'Swap created',
        description:
          'Your swap has been created. Awaiting next steps from our system.',
      }

    case 'Review':
      return {
        transferStatus: 'Review',
        title: 'Reviewing your swap',
        description:
          'We are checking your wallets and counterparties before asking you to send funds. This usually takes just a few seconds.',
      }

    case 'DepositPending':
      return {
        transferStatus: 'DepositPending',
        title: 'Waiting to receive your money',
        description: `Make a transfer to our ${
          swap.deposit?.toBankAccount ? 'bank' : 'wallet'
        }. Estimated time of confirmation: 1 hour - 1 business day.`,
      }

    case 'DepositReceived':
      return {
        transferStatus: 'DepositReceived',
        title: 'Deposit received',
        description: 'Your deposit has been received and is being processed.',
      }

    case 'WithdrawPending':
      return {
        transferStatus: 'WithdrawPending',
        title: 'Converting your funds',
        description: `We are currently converting your funds to ${swap.withdraw?.currency.isoCode}.`,
      }

    case 'OnHold':
      return {
        transferStatus: 'OnHold',
        title: 'Additional check required',
        description:
          'Your order needs an additional check. We will contact you if we need more information.',
      }

    case 'Completed':
      return {
        transferStatus: 'Completed',
        title: 'Swap successfully completed',
        description: `Your ${
          swap.withdraw?.currency.isoCode
        } has been delivered to your ${
          swap.withdraw?.toBankAccount ? 'bank account' : 'wallet'
        }.`,
      }

    case 'Cancelled':
      return {
        transferStatus: 'Cancelled',
        title: 'Swap cancelled',
        description:
          'Your swap has been cancelled. If you believe this to be an error, contact the Penning team.',
      }

    case 'Rejected':
      return {
        transferStatus: 'Rejected',
        title: 'Swap rejected',
        description:
          'Your swap has been rejected. Please contact support for more information.',
      }

    default:
      return {
        transferStatus: 'Created',
        title: 'Swap created',
        description:
          'Your swap has been created. Awaiting next steps from our system.',
      }
  }
}
